module.exports = __webpack_public_path__ + "img/articles4.9f8aa8d9.jpg";